"use client";
import React, { useEffect, useState } from "react";
import {
  Box,
  Text,
  VStack,
  HStack,
  Stack,
  useMediaQuery,
  Spinner,
  Flex,
  Input,
} from "@chakra-ui/react";
import HeaderTools from "../../components/HeaderTools";
import api from "../../services/api";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

// Mock data dos pedidos

const STATUS_LABELS = {
  PENDENTE: "Pendente",
  CONFIRMADO: "Confirmado",
  CANCELADO: "Cancelado",
  FINALIZADO: "Finalizado",
  SEPARADO: "Separado",
  ENVIADO: "Enviado",
};

const STATUS_COLORS = {
  PENDENTE: "#dd6b20",
  CONFIRMADO: "#2998D4",
  CANCELADO: "#C01B0D",
  FINALIZADO: "#1AB744",
  SEPARADO: "#EDB929",
  ENVIADO: "#298186",
};

export default function RelatoryOrders() {
  const [statusFilter, setStatusFilter] = useState("all");
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showSearch, setShowSearch] = useState(false);
  const [search, setSearch] = useState("");

  const [isLargerThan768] = useMediaQuery("(min-width: 768px)");
  const navigate = useNavigate();

  useEffect(() => {
    const getOrders = async () => {
      try {
        setLoading(true);
        const response = await api.get("/orders");
        setOrders(response.data);
      } catch {
        toast.error(
          "Não foi possível buscar os seus pedidos, entre em contato com o suporte.",
        );
      } finally {
        setLoading(false);
      }
    };

    getOrders();
  }, []);

  const filteredOrders = orders.filter((order) => {
    const statusMatch = statusFilter === "all" || order.status === statusFilter;
    const query = search.trim().toLowerCase();
    const searchMatch =
      !query ||
      String(order.order_number ?? "")
        .toLowerCase()
        .includes(query) ||
      (order.client?.name ?? "").toLowerCase().includes(query) ||
      (order.client?.email ?? "").toLowerCase().includes(query);
    return statusMatch && searchMatch;
  });

  return (
    <>
      <HeaderTools
        title="Pedidos"
        onClickSearch={() => setShowSearch((prev) => !prev)}
        showSearch
      />
      <Box
        padding={{ base: "16px", md: "20px" }}
        bg="gray.50"
        minHeight="100vh"
      >
        <HStack spacing={4} mb={6} display={{ base: "none", md: "flex" }}>
          <select
            style={{
              padding: "12px",
              backgroundColor: "white",
              border: "1px solid #e2e8f0",
              borderRadius: "6px",
              fontSize: "16px",
              maxWidth: "200px",
            }}
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            <option value="all">Todos os status</option>
            <option value="PENDENTE">Pendente</option>
            <option value="CONFIRMADO">Confirmado</option>
            <option value="CANCELADO">Cancelado</option>
          </select>
        </HStack>

        {/* Lista de Pedidos */}
        <VStack spacing={0} align="stretch">
          {loading ? (
            <Flex width="100%" justify="center">
              <Spinner />
            </Flex>
          ) : null}
          {showSearch && (
            <Input
              placeholder="Pesquisar por número do pedido, cliente ou e-mail..."
              backgroundColor="white"
              padding="15px"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          )}
          {filteredOrders.map((order, index) => (
            <Box
              key={order.id}
              bg="white"
              p={{ base: 4, md: 6 }}
              cursor="pointer"
              _hover={{ bg: "gray.50" }}
              transition="background 0.2s"
              borderBottom={
                index < filteredOrders.length - 1 ? "1px solid #e0e0e0" : "none"
              }
              borderRadius={
                index === 0
                  ? "8px 8px 0 0"
                  : index === filteredOrders.length - 1
                    ? "0 0 8px 8px"
                    : "0"
              }
              onClick={() => navigate(`/pedido/${order.id}`)}
            >
              <VStack align="start" spacing={2}>
                <Text
                  fontSize={{ base: "12px", md: "13px" }}
                  fontWeight="bold"
                  color="white"
                  bg={STATUS_COLORS[order.status] || "gray.400"}
                  px={2}
                  py="2px"
                  borderRadius="4px"
                >
                  {STATUS_LABELS[order.status] || order.status}
                </Text>
                <Text
                  fontWeight="bold"
                  fontSize={{ base: "16px", md: "18px" }}
                  color="gray.800"
                >
                  {order.client?.name}
                </Text>
                <Text fontSize={{ base: "14px", md: "16px" }} color="gray.800">
                  {order.client?.email}
                </Text>
                <Text fontSize={{ base: "14px", md: "15px" }} color="gray.600">
                  {new Intl.DateTimeFormat("pt-BR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  }).format(new Date(order.createdAt))}
                </Text>
                <Text
                  fontWeight="bold"
                  fontSize={{ base: "16px", md: "18px" }}
                  color="gray.800"
                >
                  {new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  }).format(order.totalValue)}
                </Text>
                <Text fontSize={{ base: "12px", md: "13px" }} color="gray.500">
                  Nº {order.order_number}
                </Text>
              </VStack>
            </Box>
          ))}
        </VStack>

        {filteredOrders.length === 0 && (
          <Box textAlign="center" py={10}>
            <Text color="gray.500" fontSize={{ base: "14px", md: "16px" }}>
              Nenhum pedido encontrado com os filtros selecionados.
            </Text>
          </Box>
        )}
      </Box>
    </>
  );
}
